module.exports = __webpack_public_path__ + "static/media/214x152_2 copy.36fe8cee.png";